import { Card } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import { Pie } from "react-chartjs-2";
import { pieOption } from "../chartOptions";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function Overlap50Chart({ data, loading, error }) {
    const chartData = useMemo(() => {
        if (data) {
            const commonPercentage = (data.common * 100) / (data.unique + data.common);
            const uniquePercentage = (data.unique * 100) / (data.unique + data.common);

            return {
                labels: ["Unique", "In Common"],
                datasets: [
                    {
                        type: "pie",
                        backgroundColor: ["#7BA7CC", "#396A93"],
                        data: [uniquePercentage, commonPercentage],
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="text-center">Top 50 Overlap</Card.Header>
            <Card.Body className="card-dashboard-music-chart d-flex pt-0 pb-1 justify-content-center align-items-center ">
                {loading ? <LoadingIndicator width={75} /> : error ? <ErrorResponse errorCode={error} /> : data && <Pie data={chartData} options={pieOption} />}
            </Card.Body>
        </Card>
    );
}
